export const PAR_SOLUTIONS = [
  "PAR Scales",
  "PAR 360 Plus",
  "PAR 360 Premium",
  "Electronic Shelf Labels (ESLs)",
  "TrackCore IR",
  "TrackCore OR",
  "PAR SameDay",
  "Notisphere",
] as const;
